import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faChartColumn, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import CustomSearch from "components/searchbar/CustomSearch";
import { motion } from 'framer-motion';
import DemoReportFilter from 'pages/summary/demo/DemoReportFilter';

interface DashboardControlsProps {
  isDemoView: boolean;
  isVisitView: boolean;
  onToggleDemoView: () => void;
  onToggleVisitView: () => void;
  onOpenFilter: () => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onResetFilter: () => void;
  isFilterApplied: boolean;
  filterCount: number;
}

const DashboardControls: React.FC<DashboardControlsProps> = ({
  isDemoView,
  isVisitView,
  onToggleDemoView,
  onToggleVisitView,
  onOpenFilter,
  searchTerm,
  onSearchChange,
  onResetFilter,
  isFilterApplied,
  filterCount,

}) => {

  const handleFilterClose = () => {
    console.log("Hell");
  }

  const onSubmit = () => {
    console.log('hello');
  }
  const handleClearFilter = () => {
    console.log("New ram")
  }
  return (
    <div className="pb-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 py-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
        {/* View Toggle Buttons */}
        <div className="flex items-center gap-3 text-md font-semibold">
          <button
            onClick={onToggleDemoView}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${isDemoView
              ? 'bg-blue-600 text-white font-medium'
              : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-white'
              }`}
          >
            <FontAwesomeIcon icon={faChartColumn} />
            <span>Demo Dashboard</span>
          </button>
          <button
            onClick={onToggleVisitView}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${isVisitView
              ? 'bg-blue-600 text-white font-medium'
              : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600  text-gray-800 dark:text-white'
              }`}
          >
            <FontAwesomeIcon icon={faLocationDot} />
            <span>Visit Analysis</span>
          </button>
        </div>

        {/* Search & Filter */}
        <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">
          <div className="w-full sm:w-auto flex-grow sm:flex-grow-0">
            <CustomSearch value={searchTerm}
              onChange={onSearchChange}
              onSearch={onSearchChange}
              width="full"
            />
          </div>

          <div className="flex items-center gap-2 mr-3">
            <div className="relative">
              <motion.button
                // whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                // onClick={() => setsFilterApplied(!isFilterOpened)}
                onClick={onOpenFilter}
                className="relative px-3 py-2 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400 rounded-lg hover:bg-indigo-100 dark:hover:bg-indigo-800/40 transition-colors duration-200 flex items-center"
              >
                <FontAwesomeIcon icon={faFilter} className="mr-1.5" />
                <span>Filter</span>
                {isFilterApplied && filterCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-blue-600 text-[10px] text-white font-bold">
                    {filterCount}
                  </span>
                )}
              </motion.button>

              {/* {isFilterApplied && (
                <div
                  style={{
                    position: 'absolute',
                    zIndex: 50,
                    top: '100%',
                    right: 0,
                    marginTop: '8px',
                    width: '400px',
                    maxWidth: 'calc(100vw - 2rem)'
                  }}
                >
                  <DemoReportFilter onClose={handleFilterClose} title="Generate Demo Report" onSubmit={onSubmit} onReset={handleClearFilter} showCropField={true} showProductField={true} showStatus={true} />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardControls;
